import React from 'react';

const SvgMarkerEmpty = ({ svgRef, title, ...props }) => (
  <svg width="1em" height="1em" viewBox="0 0 18 26" ref={svgRef} {...props}>
    <title>{title}</title>
    <defs>
      <path id="MarkerEmpty_svg__a" d="M810.617 599c-4.764 0-8.617 3.956-8.617 8.847 0 6.635 8.617 16.43 8.617 16.43s8.617-9.795 8.617-16.43c0-4.891-3.853-8.847-8.617-8.847" />
    </defs>
    <use fill="currentColor" xlinkHref="#MarkerEmpty_svg__a" transform="translate(-802 -599)" />
  </svg>
);

const ForwardRef = React.forwardRef((props, ref) => <SvgMarkerEmpty svgRef={ref} {...props} />);
export default ForwardRef;



// WEBPACK FOOTER //
// ./src/common/icons/MarkerEmpty.js